export default __webpack_public_path__ + "static/media/qzuki-hero.7ac37395.png";